import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import ChronicleModalStore from './store';
import WikiModule from '../wiki-module';

const styles = require('./index.less');

/**
 *  编年史
 */
const ChronicleModal = ({ store, onClose }) => {
  store.use();
  // console.log(store.listLength);

  if (onClose) {
    store.closeCallback = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.chronicleModalRoot)}>
        <Link
          className={cx(store.activeIndex > 0 ? styles.switch_prev : styles.switch_unclickable_prev)}
          onClick={() => {
            store.onClickPrev();
          }}
        />
        <Link
          className={cx(store.activeIndex < store.listLength - 1 ? styles.switch_next : styles.switch_unclickable_next)}
          onClick={() => {
            store.onClickNext();
          }}
        />

        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <WikiModule data={store.data} dictData={store.dictData} characterDataMap={store.characterDataMap} factionDataMap={store.factionDataMap} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(ChronicleModal, ChronicleModalStore);
